import React from 'react';
import type { FinancialsWidgetConfig } from './types';
import { definition } from './index';

interface Props {
  config: Partial<FinancialsWidgetConfig>;
  onChange: (config: FinancialsWidgetConfig) => void;
}

const FinancialsWidgetBuilder: React.FC<Props> = () => (
  <div className="space-y-4">
    <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
      <strong>{definition.meta.label}</strong>
      <p className="mt-1">{definition.meta.description}</p>
    </div>
    <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
      <h4 className="font-medium text-primary-800 mb-2">How it works</h4>
      <ul className="text-sm text-primary-700 space-y-1 ml-5 list-disc">
        <li>Revenue and net income bars by fiscal year</li>
        <li>Headline shows the latest year's revenue, net income, and net margin</li>
        <li>Sourced from FMP income statements, with SimFin point-in-time statements as fallback</li>
      </ul>
    </div>
  </div>
);

export default FinancialsWidgetBuilder;
